module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__paymentmethods"
    }
  }, [_c('md-content', {
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "showAddButton": false,
      "total": _vm.methodsAmount,
      "link": "",
      "table-id": "paymentmethods"
    },
    on: {
      "refresh": _vm.getMethods
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function(scope) {
        return (scope.item.type) ? _c('span', {}, [_vm._v(_vm._s((_vm.types && _vm.types[scope.item.type]) ? _vm.types[scope.item.type]['name'] : ''))]) : _vm._e()
      }
    }, {
      key: "active",
      fn: function(scope) {
        return _c('span', {}, [_vm._v(_vm._s((scope.item.active && parseInt(scope.item.active) !== 0) ? 'Автивен' : 'Отключён'))])
      }
    }, {
      key: "public",
      fn: function(scope) {
        return _c('span', {}, [_vm._v(_vm._s((scope.item.public && parseInt(scope.item.public) !== 0) ? 'Да' : 'Нет'))])
      }
    }]),
    model: {
      value: (_vm.methods),
      callback: function($$v) {
        _vm.methods = $$v
      },
      expression: "methods"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2194a5b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/PaymentMethods.vue
// module id = 1068
// module chunks = 0